// extracted by mini-css-extract-plugin
export default {"liveFeedContainer":"vNBSg","title":"bY5P6"};